import React, {useState, useEffect} from 'react';

import {observer} from 'mobx-react';
import {ObservableMap} from 'mobx';

import {useStores} from '../../../Hooks';
import {procedureTypeEnum} from '../../../serverClientShared/sharedEnums';
import ItemSettingsTab from './ItemSettingsTab';
import AdvancedSettingsTab from './AdvancedSettingsTab';
import MirroredSettingsTab from './MirroredSettingsTab';

const SettingsTabBody = observer(({activeTab, settings}) => {
    const {projectStore, dataStore} = useStores();
    const [threeDModels, setThreeDModels] = useState([]);
    const {procedure} = settings;

    useEffect(() => {
        const projectId = projectStore.currentProject?.ProjectIdentifier;
        const map = dataStore.projectsProceduresMap.get(projectId) || new ObservableMap();
        setThreeDModels(Array.from(map.values()).filter((p) => p.ProcedureType === procedureTypeEnum.FUSION));
    }, [procedure]);

    if (procedure?.importedFromWorkspace) {
        return <MirroredSettingsTab settings={settings} />;
    }
    if (activeTab === 0) {
        return <ItemSettingsTab settings={settings} threeDModels={threeDModels} />;
    }
    return <AdvancedSettingsTab settings={settings} />;
});

export default SettingsTabBody;
